import { ApiType, delogueApi } from 'lib/api';

export const apiCurrentUser: ApiType = {
  get: {
    loggedInUser: () => delogueApi.get('/api/user'),
    /**
     * Designer/brand organizations the signed-in supplier user is associated with
     * (Nexos `GET /api/users/me/designer-organizations`, DL-62658). Replaces the legacy
     * `GET /api/supplierportalaccount/associated-brands` and matches it exactly: both
     * key on `LoginId`, so the list spans every supplier account the login holds, and
     * both fix the association to Active and the organization to active.
     *
     * Flat + unpaginated `{ id, name, type }[]`, supplier-admin only, ordered by name.
     * `search` is the only filter, applied in SQL.
     */
    associatedOrganizations: ({ query }) =>
      delogueApi.get('/api/users/me/designer-organizations', query),
  },
  put: {},
  post: {},
  delete: {},
};
